import { ApplicationConfig, importProvidersFrom, provideNgReflectAttributes, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { routes } from '@app/app.routes';
import { provideStore } from '@ngrx/store';
import { CoreModule } from '@app/core/core.module';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { provideRsAmplitude } from '@rs-shared-lib/providers/amplitude-provider';
import { OrdAmplitudeService } from '@shared/services/amplitude/ord-amplitude.service';

const globalDialogDefaultsOptions: MatDialogConfig = {
  width: '800px',
};

const globalFormFieldDefaultOptions: MatFormFieldDefaultOptions = {
  appearance: 'outline',
  subscriptSizing: 'dynamic',
};

const materialProviders = [
  { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: globalDialogDefaultsOptions },
  { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: globalFormFieldDefaultOptions }
]

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Do not rely on ng-reflect attributes; they are planned for deprecation in the future.
    provideNgReflectAttributes(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled'
      }),
      withComponentInputBinding(),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'always'
      })
    ),
    provideStore(),
    provideRsAmplitude(OrdAmplitudeService),
    importProvidersFrom(CoreModule),
    ...materialProviders,
  ]
};
